"use client";

import { c as _c } from "react/compiler-runtime";
import type { CreateWaveDropsRequiredMetadata } from "@/types/waves.types";
import CreateWaveDropsMetadataRow from "./CreateWaveDropsMetadataRow";
import CreateWaveDropsMetadataAddRowButton from "./CreateWaveDropsMetadataAddRowButton";
import { ApiWaveMetadataType } from "@/generated/models/ApiWaveMetadataType";
import { CREATE_WAVE_VALIDATION_ERROR } from "@/helpers/waves/create-wave.validation";
import { IDENTITY_SUBMISSION_RESERVED_METADATA_ERROR, isReservedIdentitySubmissionMetadataKey } from "@/helpers/waves/identity-submission-metadata";
const NON_UNIQUE_METADATA_ERROR = "Metadata name must be unique";
export default function CreateWaveDropsMetadata(t0) {
  const $ = _c(48);
  const {
    requiredMetadata,
    errors,
    onRequiredMetadataChange
  } = t0;
  let t1;
  if ($[0] !== onRequiredMetadataChange || $[1] !== requiredMetadata) {
    t1 = t2 => {
      const {
        index,
        key,
        type
      } = t2;
      const newItems = [...requiredMetadata];
      newItems[index] = {
        key,
        type
      };
      onRequiredMetadataChange(newItems);
    };
    $[0] = onRequiredMetadataChange;
    $[1] = requiredMetadata;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const onItemChange = t1;
  let t2;
  if ($[3] !== onRequiredMetadataChange || $[4] !== requiredMetadata) {
    t2 = () => {
      onRequiredMetadataChange([...requiredMetadata, {
        key: "",
        type: ApiWaveMetadataType.String
      }]);
    };
    $[3] = onRequiredMetadataChange;
    $[4] = requiredMetadata;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const onAddNewRow = t2;
  let t3;
  if ($[6] !== onRequiredMetadataChange || $[7] !== requiredMetadata) {
    t3 = index_0 => {
      const newItems_0 = [...requiredMetadata];
      newItems_0.splice(index_0, 1);
      onRequiredMetadataChange(newItems_0);
    };
    $[6] = onRequiredMetadataChange;
    $[7] = requiredMetadata;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const onRemoveRow = t3;
  let t4;
  if ($[9] !== errors) {
    t4 = errors.includes(CREATE_WAVE_VALIDATION_ERROR.DROPS_REQUIRED_METADATA_NON_UNIQUE);
    $[9] = errors;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const haveNonUniqueMetadata = t4;
  let t5;
  if ($[11] !== errors) {
    t5 = errors.includes(CREATE_WAVE_VALIDATION_ERROR.DROPS_REQUIRED_METADATA_RESERVED_IDENTITY_KEY);
    $[11] = errors;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const haveReservedIdentityMetadata = t5;
  let t6;
  if ($[13] !== requiredMetadata) {
    t6 = requiredMetadata.reduce(_temp, {});
    $[13] = requiredMetadata;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const keyOccurrences = t6;
  let t7;
  if ($[15] !== keyOccurrences) {
    t7 = new Set(Object.values(keyOccurrences).flatMap(_temp2));
    $[15] = keyOccurrences;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  const nonUniqueMetadataIdxs = t7;
  let t10;
  let t11;
  let t12;
  let t8;
  let t9;
  if ($[17] !== haveNonUniqueMetadata || $[18] !== haveReservedIdentityMetadata || $[19] !== nonUniqueMetadataIdxs || $[20] !== onItemChange || $[21] !== onRemoveRow || $[22] !== requiredMetadata) {
    const reservedIdentityMetadataIdxs = requiredMetadata.reduce(_temp3, []);
    const getRowErrorMessage = index_3 => {
      if (reservedIdentityMetadataIdxs.includes(index_3) && haveReservedIdentityMetadata) {
        return IDENTITY_SUBMISSION_RESERVED_METADATA_ERROR;
      }
      if (nonUniqueMetadataIdxs.has(index_3) && haveNonUniqueMetadata) {
        return NON_UNIQUE_METADATA_ERROR;
      }
      return null;
    };
    if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
      t12 = <p className="tw-mb-0 tw-text-lg tw-font-semibold tw-text-iron-50 sm:tw-text-xl">Required metadata</p>;
      $[28] = t12;
    } else {
      t12 = $[28];
    }
    t11 = "tw-mt-3 tw-grid tw-grid-cols-2 tw-gap-x-4 tw-gap-y-4";
    t10 = "tw-col-span-full tw-flex tw-flex-col tw-gap-y-2";
    t8 = "tw-flex tw-flex-col tw-gap-y-4";
    t9 = requiredMetadata.map((item_1, i) => <CreateWaveDropsMetadataRow key={`create-wave-drops-metadata-row-${i}`} item={item_1} index={i} errorMessage={getRowErrorMessage(i)} onItemChange={onItemChange} onItemRemove={onRemoveRow} />);
    $[17] = haveNonUniqueMetadata;
    $[18] = haveReservedIdentityMetadata;
    $[19] = nonUniqueMetadataIdxs;
    $[20] = onItemChange;
    $[21] = onRemoveRow;
    $[22] = requiredMetadata;
    $[23] = t10;
    $[24] = t11;
    $[25] = t12;
    $[26] = t8;
    $[27] = t9;
  } else {
    t10 = $[23];
    t11 = $[24];
    t12 = $[25];
    t8 = $[26];
    t9 = $[27];
  }
  let t13;
  if ($[29] !== requiredMetadata.length) {
    t13 = requiredMetadata.length === 0 && <div className="tw-py-2 tw-text-sm tw-font-medium tw-italic tw-text-iron-400">No required metadata added</div>;
    $[29] = requiredMetadata.length;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== t13 || $[32] !== t8 || $[33] !== t9) {
    t14 = <div className={t8}>{t9}{t13}</div>;
    $[31] = t13;
    $[32] = t8;
    $[33] = t9;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  let t15;
  if ($[35] !== onAddNewRow || $[36] !== requiredMetadata.length) {
    t15 = <CreateWaveDropsMetadataAddRowButton itemsCount={requiredMetadata.length} onAddNewRow={onAddNewRow} />;
    $[35] = onAddNewRow;
    $[36] = requiredMetadata.length;
    $[37] = t15;
  } else {
    t15 = $[37];
  }
  let t16;
  if ($[38] !== t10 || $[39] !== t14 || $[40] !== t15) {
    t16 = <div className={t10}>{t14}{t15}</div>;
    $[38] = t10;
    $[39] = t14;
    $[40] = t15;
    $[41] = t16;
  } else {
    t16 = $[41];
  }
  let t17;
  if ($[42] !== t11 || $[43] !== t16) {
    t17 = <div className={t11}>{t16}</div>;
    $[42] = t11;
    $[43] = t16;
    $[44] = t17;
  } else {
    t17 = $[44];
  }
  let t18;
  if ($[45] !== t12 || $[46] !== t17) {
    t18 = <div>{t12}{t17}</div>;
    $[45] = t12;
    $[46] = t17;
    $[47] = t18;
  } else {
    t18 = $[47];
  }
  return t18;
}
function _temp3(acc_0, item_0, index_2) {
  if (isReservedIdentitySubmissionMetadataKey(item_0.key)) {
    acc_0.push(index_2);
  }
  return acc_0;
}
function _temp2(indices_0) {
  return indices_0.length > 1 ? indices_0 : [];
}
function _temp(acc, item, index_1) {
  const indices = acc[item.key];
  if (indices) {
    indices.push(index_1);
  } else {
    acc[item.key] = [index_1];
  }
  return acc;
}